module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA+UlEQVRYR+2XURHCQAxEdxWAA0AB1AE4wAE4YHBQCcVBnVAHFAWAA1AQZqHXuc7AZ3P96AnoJi932w2R+DCxPoZTgJlNASydiFxJPqX1IdCIXwDMnQqoSWZxAWsAZyfxILMhWQUC6rwGMHEq4iXaGkN7Cc1sBWDrVEBJ8t6OwEn0p8xwnmEqCiOB4RAwswLAwekuFCSPqZ0wI1kHJ5QJ6V/geRYyo9gJcwB7ALOeq3gAyEmWoxOOBEYCHQJmpli2c8iFCiInmVDshIpkt57ff/x5JWIZ0TeSNd0nDaXaCSrnvUD2392MGhK9T0JxPIgMJw/03vYfgeQE3j0+SSEiGYGCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/list.png
// module id = d/f2
// module chunks = 56